import InstoreCodeDialog from './InstoreCodeDialog';

export default InstoreCodeDialog;
